import { AppConfig } from '../types';
import { defaultData } from '../data/defaultData';

export function sanitizeConfig(config?: Partial<AppConfig> | null): AppConfig {
  const base = defaultData.config;
  if (!config) return base;

  return {
    ...base,
    ...config,
    logoUrl: config.logoUrl || base.logoUrl || '',
    contact: {
      ...base.contact,
      ...(config.contact || {})
    },
    social: {
      ...base.social,
      ...(config.social || {})
    },
    seo: {
      ...base.seo,
      ...(config.seo || {})
    },
    team: Array.isArray(config.team) && config.team.length > 0 ? config.team : base.team,
    testimonials: Array.isArray(config.testimonials) ? config.testimonials : base.testimonials,
    showreels: Array.isArray(config.showreels) ? config.showreels : base.showreels
  };
}
